import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkLink from 'react/shared/components/true_link/main/TrueLinkLink';
import PALETTE from 'react/shared/theme/palette';

const useStyles = makeStyles({
  reviewLabel: {
    color: PALETTE.grey2,
  },
});

export default function ReviewRow({ className, label, onEdit, value }) {
  const classes = useStyles();

  return (
    <Grid className={className} container spacing={3}>
      <Grid container item xs={10}>
        <Grid item sm={4} xs={12}>
          <CardText className={classes.reviewLabel}>{label}</CardText>
        </Grid>
        <Grid item sm={8} xs={12}>
          {value}
        </Grid>
      </Grid>
      <Grid item xs={2}>
        {onEdit && (
          <CardText>
            <TrueLinkLink onClick={onEdit}>Edit</TrueLinkLink>
          </CardText>
        )}
      </Grid>
    </Grid>
  );
}

ReviewRow.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
  onEdit: PropTypes.func,
  value: PropTypes.node.isRequired,
};
